import ContentUtils from "@/content/util/contentUtils"
import Relay from "@/relay/relayUtils"
import { SelectOption } from "@disco-ui"
import DiscoPaginatedDropdownContent, {
  DiscoPaginatedDropdownContentSkeleton,
} from "@disco-ui/dropdown/DiscoPaginatedDropdownContent"
import { TestIDProps } from "@utils/typeUtils"
import { useMemo } from "react"

type ContentLabelOption = SelectOption<string | "all">

export type ContentLabelFilterDropdownContentState = {
  allContentLabels: ContentLabelOption | null
  contentLabels: ContentLabelOption[]
}

export interface ContentLabelFilterDropdownContentProps extends TestIDProps {
  filterState: ContentLabelFilterDropdownContentState
  setFilterState: (state: ContentLabelFilterDropdownContentState) => void
  multiSelect?: boolean
}

function ContentLabelFilterDropdownContent({
  filterState,
  setFilterState,
  multiSelect = false,
}: ContentLabelFilterDropdownContentProps) {
  const selectedOptions = useMemo(() => {
    return [
      ...(filterState.allContentLabels ? [filterState.allContentLabels] : []),
      ...filterState.contentLabels,
    ]
  }, [filterState.allContentLabels, filterState.contentLabels])

  const { contentLabels, pagination } = ContentUtils.usePaginatedContentLabels()

  const options = [
    { value: "all", title: "All" },
    ...contentLabels.map((contentLabel) => ({
      value: contentLabel.id,
      title: contentLabel.label,
    })),
  ]

  return (
    <DiscoPaginatedDropdownContent
      testid={"ContentLabel.content-label-select"}
      pagination={pagination}
      onOptionSelect={handleSelect}
      options={options}
      selectedOptions={selectedOptions}
    />
  )

  function handleSelect(option: ContentLabelOption | null) {
    const state: ContentLabelFilterDropdownContentState = {
      allContentLabels: null,
      contentLabels: [],
    }

    if (option?.value === "all") {
      state.allContentLabels = option
    } else if (option) {
      state.contentLabels = multiSelect
        ? filterState.contentLabels?.concat(option) ?? [option]
        : [option]
    }

    setFilterState(state)
  }
}

const ContentLabelFilterDropdownContentSkeleton = () => {
  return <DiscoPaginatedDropdownContentSkeleton />
}

export default Relay.withSkeleton({
  component: ContentLabelFilterDropdownContent,
  skeleton: ContentLabelFilterDropdownContentSkeleton,
})
